import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Login from 'views/public/Login'
import ForgotPassword from 'views/public/ForgotPassword'
import ResetPassword from 'views/public/ResetPassword'
import SetPassword from 'views/public/SetPassword'
import ConferenceSelector from 'views/public/ConferenceSelector'

import { LinearProgress, MuiThemeProvider } from '@material-ui/core'
import { lightTheme } from 'config/theme'
import Template from 'components/Template'
import CssBaseline from '@material-ui/core/CssBaseline'
import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ConfirmProvider } from 'material-ui-confirm'
import { fetchConference, fetchConferenceById } from 'store/conference'
import { Roles } from 'constants/index'
import moment from 'moment'
import 'moment-timezone'
import { isEmpty } from 'lodash'
import PoolForm from 'views/admin/polling/public/PoolForm'
import PollView from 'views/admin/polling/public/PollView'
import PrivacyPolicy from 'views/public/PrivacyPolicy'
import NotFound from 'components/NotFound'
import { fetchSettings } from 'store/settings'
import Public from 'views/admin/organizations/components/Public'
import SpeakerProfile from 'views/admin/people/components/SpeakerProfile'
import { Toaster } from 'sonner'
import 'styles/toast.css'

const App = () => {
  const { inProgress, user } = useSelector((state) => state.auth)
  const { conference } = useSelector((state) => state.conference)

  const dispatch = useDispatch()
  !isEmpty(conference) && moment.tz.setDefault(conference?.timezone)

  useEffect(() => {
    if (user && user.role === Roles.SUPER_ADMIN) {
      dispatch(fetchConference())
    } else if (user) {
      dispatch(fetchConferenceById(user.conferenceId))
      dispatch(fetchSettings(user?.conferenceId))
    }
  }, [user])

  return (
    <MuiThemeProvider theme={lightTheme}>
      <ConfirmProvider>
        <CssBaseline />
        <Toaster
          position="top-center"
          offset={{ top: 70 }}
          toastOptions={{
            duration: 3000,
            closeButton: true
          }}
        />
        {inProgress ? (
          <LinearProgress color="secondary" />
        ) : (
          <Router>
            <Switch>
              <Route path="/" exact>
                <Login />
              </Route>
              <Route path="/select-conference" exact>
                <ConferenceSelector />
              </Route>
              <Route path="/forgot-password" exact>
                <ForgotPassword />
              </Route>
              <Route path="/reset-password" exact>
                <ResetPassword />
              </Route>
              <Route path="/set-password" exact>
                <SetPassword />
              </Route>
              <Route path="/privacy-policy" exact>
                <PrivacyPolicy />
              </Route>

              <Route path="/organization-profile" exact>
                <Public />
              </Route>

              <Route path="/public/speakers/profile" exact>
                <SpeakerProfile />
              </Route>

              <Route path="/polling" exact>
                <PoolForm />
              </Route>
              <Route path="/polls/:pollId" exact>
                <PollView />
              </Route>
              <Route path="/admin">
                <Template />
              </Route>
              <Route path="*">
                <NotFound />
              </Route>
            </Switch>
          </Router>
        )}
      </ConfirmProvider>
    </MuiThemeProvider>
  )
}

export default App
